export default __webpack_public_path__ + "static/media/the_pope_video_it.a7482809.svg";